const DAY_OF_WEEK = ['日', '月', '火', '水', '木', '金', '土']

/**
 * UTC日時文字列をJST表示用にフォーマットする
 * 例: "2025-01-15T03:00:00.000Z" → "2025-01-15 (水) 12:00"
 * @param dateString ISO 8601形式の日時文字列
 * @returns フォーマット済み文字列。nullish な場合は '-' を返す
 */
export function formatDatetimeJST(dateString: string | null | undefined): string {
  if (!dateString) {
    return '-'
  }

  const date = new Date(dateString)
  if (isNaN(date.getTime())) {
    return '-'
  }
  const jst = new Date(date.getTime() + 9 * 60 * 60 * 1000)

  const year = jst.getUTCFullYear()
  const month = String(jst.getUTCMonth() + 1).padStart(2, '0')
  const day = String(jst.getUTCDate()).padStart(2, '0')
  const dayOfWeek = DAY_OF_WEEK[jst.getUTCDay()]
  const hours = String(jst.getUTCHours()).padStart(2, '0')
  const minutes = String(jst.getUTCMinutes()).padStart(2, '0')

  return `${year}-${month}-${day} (${dayOfWeek}) ${hours}:${minutes}`
}
